import { Injectable } from "@angular/core";
import { HttpParams } from "@angular/common/http";
import { HttpService } from "../utils/http-service.service";

@Injectable({
  providedIn: 'root'
})
export class RhNetService  {

  constructor(private service: HttpService) {
  }

  getServidorByCPF(params){
    const httpParams = new HttpParams().set('type', 'onlyRHNet');
    return this.service.sendGet(`admin/servidoresRHNet/${params.cpf}`, httpParams);
  }

  /**
   * Salva o servidor no banco de dados usando o tipo FIRST_RHNET
   * Isso garante que os vínculos sejam salvos corretamente com o status ativo
   */
  salvarServidorNoBanco(cpf: string){
    const httpParams = new HttpParams().set('type', 'firstRHNet');
    return this.service.sendGet(`admin/servidoresRHNet/${cpf}`, httpParams);
  }
}
